import { create } from "zustand";

export function createErrorsStore<T extends Record<string, string | null>>(
  initialErrors: T,
) {
  return create<{
    errors: T;
    isValidated: boolean;
    setErrors: (errors: Partial<T>) => void;
    setIsValidated: (isValidated: boolean) => void;
    resetErrors: () => void;
  }>((set) => ({
    errors: initialErrors,
    isValidated: false,
    setIsValidated: (isValidated: boolean) => set(() => ({ isValidated })),
    setErrors: (errors) =>
      set((state) => ({ errors: { ...state.errors, ...errors } })),
    resetErrors: () => set(() => ({ errors: initialErrors })),
  }));
}
